// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchTerritoriesPage-wrapper {
  padding: 24px;
}
.SearchTerritoriesPage-wrapper .tabs-wrapper {
  padding-top: 0px;
}
.SearchTerritoriesPage-wrapper .width-wrapper-component {
  padding: 0px;
}`, "",{"version":3,"sources":["webpack://./src/pages/SearchTerritoriesPage/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,YAAA;AAAJ","sourcesContent":[".SearchTerritoriesPage-wrapper {\n  padding: 24px;\n\n  .tabs-wrapper {\n    padding-top: 0px;\n  }\n\n  .width-wrapper-component {\n    padding: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
